import { get, find, isNil } from 'lodash';

import { required } from '../../../../../../common/services/ValidationRules';
import { parsePhases } from '../helper';
import { makePhaseConnectivityRule, makePhasesRule } from './common';
import { DEFAULT_COMMON_PROPS_TAB_TITLE } from './const';
import { ROOT_NODE_TYPE } from '../../../constants';

const CONSTRAINT_NODE_FORM_RULE = {
  dialog: {
    maxWidth: 'sm',
  },
  tabs: [
    {
      title: DEFAULT_COMMON_PROPS_TAB_TITLE,
      fields: [
        {
          label: 'Hard Constraint Node Name',
          source: 'staticSection.nodeName',
          name: 'nodeName',
          type: 'text',
          required: true,
          validators: [required],
          style: {
            width: '49%',
          },
        },
        {
          label: 'Max Load (A)',
          source: 'staticSection.maxCurrentLimit',
          name: 'maxCurrentLimit',
          type: 'number',
          required: true,
          validators: [required],
          style: {
            width: '49%',
          },
          // Recalculate option allows you to change value in this field if it is in the same node
          // It will get field by name===recalculate from DOM tree!
          recalculate: 'adjustedMaxLoad',
        },
        makePhaseConnectivityRule(),
        {
          label: 'Adjusted Max Load (A)',
          name: 'adjustedMaxLoad',
          type: 'number',
          style: {
            width: '49%',
          },
          readOnly: true,
          // Calculate option will calculate value from CALCULATE_VALUE_RULES placed in constants/index.js
          calculate: true,
        },
        makePhasesRule(),
      ],
    },
  ],
  savingMap: (props) => ({
    ...props,
    staticSection: {
      ...props.staticSection,
      phases: parsePhases(props.staticSection.phases),
    },
  }),
};

export const getAdjustedMaxLoad = (maxLoad, safetyMargin) => {
  if (!safetyMargin) {
    return maxLoad;
  }

  return parseFloat(maxLoad) - (parseFloat(maxLoad) * parseFloat(safetyMargin) / 100);
};

export const CONSTRAINT_CALCULATE_VALUE_RULES = (params) => {
  const { node, nodes, valueForUpdate } = params;
  const maxCurrenLimit = valueForUpdate || get(node, 'staticSection.maxCurrentLimit');
  const rootNode = find(nodes, { topologyNodeType: ROOT_NODE_TYPE });
  const safetyMarginPercent = get(rootNode, 'staticSection.safetyMarginPercent');

  if (isNil(maxCurrenLimit) || isNil(safetyMarginPercent)) {
    return maxCurrenLimit;
  }

  return getAdjustedMaxLoad(+maxCurrenLimit, safetyMarginPercent);
};

export default CONSTRAINT_NODE_FORM_RULE;
